import Vue from "vue";
// import '@/assets/styles/antdv-vars.less'
// base library

import {
  ConfigProvider,
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Form,
  FormModel,
  Row,
  Col,
  Transfer,
  Modal,
  Table,
  Tabs,
  Icon,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Breadcrumb,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  PageHeader,
  Result,
  Statistic,
  Descriptions,
  message,
  notification,
  Empty,
  Tree,
  TreeSelect,
  Collapse,
  Cascader,
  Anchor,
  Timeline,
  Pagination,
  Rate,
  LocaleProvider
} from "ant-design-vue";
import Space from "ant-design-vue/es/space/index";
import "ant-design-vue/es/space/style/index";

Modal.props.okText.default = "确定";
Modal.props.cancelText.default = "取消";

Modal.props.maskClosable.default = false;
Drawer.props.maskClosable.default = false;

Select.props.placeholder.default = '请选择';
Input.props.placeholder = {
  type: Input.props.placeholder,
  default: '请输入'
}
InputNumber.props.placeholder.default = '请输入';

let originalvalidate = FormModel.methods.validate;
// 在原validate方法上，增加滚动到错误DOM的功能
FormModel.methods.validateScroll = function(callback) {
  let _this = this;

  if (callback) {
    originalvalidate.call(_this, (valid) => {
      callback(valid);

      if (!valid) {
        scrollToErrorDOM(_this.$el);
      }
    });
  } else {
    return new Promise((resolve, reject) => {
      originalvalidate.call(_this, (valid) => {
        if (valid) {
          resolve(valid);
        } else {
          reject(valid);
          scrollToErrorDOM(_this.$el);
        }
      });
    });
  }
};

function scrollToErrorDOM(el) {
  setTimeout(() => {
    let errorFormItem = el.querySelector(".has-error");
    // console.log("errorFormItem", errorFormItem, el);

    if (errorFormItem) {
      errorFormItem.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  });
}

/**
 * 要设置自动生成id的组件
 * {
 *   idName: 组件名
 *   type: v-id 指令的参数，如 type: input, 则指令为 v-id:input="idName"
 * }
 */
let idDirectiveConfig = _.keyBy(
  [
    {
      idName: "AInput",
      type: "input",
    },
    {
      idName: "AInputNumber",
      type: "input",
    },
    {
      id: 'ATextarea',
      type: "input",
    },
    {
      idName: "AButton",
      type: "",
    },
    // 目前select组件再封装后，会导致 dropdownRender slot 无法使用，所以暂时不加id
    // {
    //   idName: 'ASelect', 
    //   type: ''
    // },
    {
      idName: "ACheckbox",
      type: "input",
    },
    {
      idName: "ACheckboxGroup",
      type: "input",
    },
    {
      idName: "ARadioGroup",
      type: "radioGroup",
    },
    {
      idName: "AInputSearch",
      type: "inputSearch",
    },
    {
      idName: "ATabs",
      type: "tabPane",
    },
    {
      idName: "APagination",
      type: "pagination",
    },
    {
      idName: 'AModal',
      type: 'modal'
    }
  ],
  "idName"
);

/**
 * 暂时重新 Vue.component，会在组成完 ant-design 组件后还原
 */
let vueComponentFn = Vue.component;

Vue.component = function(...params) {
  let newParams = [...params];

  if (idDirectiveConfig[params[0]]) {
    newParams[1] = createFunctionalComp(
      params[1],
      idDirectiveConfig[params[0]]
    );
  }

  vueComponentFn.apply(Vue, newParams);
};

function createFunctionalComp(comp, params) {
  let { idName, type, props } = params;
  return {
    functional: true,
    model: comp.model,
    render (createElement, context) {

      // 完全透传任何 attribute、事件监听器、子节点等。
      return createElement(
        comp,
        {
          ...context.data,

          scopedSlots: Object.entries(context.slots()).reduce((pre, [key, value]) => {
            pre[key] = () => value;
            return pre;
          }, {}),

          // 添加v-id指令
          directives: [
            {
              name: "id",
              value: idName,
              arg: type,
            },
            ...(context.data.directives || []),
          ],
        },
        context.children
      );
    },
  };
}

Vue.use(Space);
Vue.use(Rate);
Vue.use(Transfer);
Vue.use(ConfigProvider);
Vue.use(Layout);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Button);
Vue.use(Switch);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Card);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(Row);
Vue.use(Col);
Vue.use(Modal);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Badge);
Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(List);
Vue.use(Avatar);
Vue.use(Breadcrumb);
Vue.use(Steps);
Vue.use(Spin);
Vue.use(Menu);
Vue.use(Drawer);
Vue.use(Tooltip);
Vue.use(Alert);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Skeleton);
Vue.use(Popconfirm);
Vue.use(PageHeader);
Vue.use(Result);
Vue.use(Statistic);
Vue.use(Descriptions);
Vue.use(Empty);
Vue.use(Tree);
Vue.use(TreeSelect);
Vue.use(Collapse);
Vue.use(Cascader);
Vue.use(Anchor);
Vue.use(Timeline);
Vue.use(Pagination);
Vue.use(LocaleProvider);

// 还原
Vue.component = vueComponentFn;

Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$confirmPromise = (params) =>
  new Promise((res) => {
    Modal.confirm({
      ...params,
      onOk: () => res(true),
      onCancel: () => res(false),
    });
  });
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$scrollToError = (formEl) => {
  const errorForm = formEl.querySelector(".has-error");
  if (errorForm) {
    errorForm.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }
};



Vue.useAntD = true;
